// @flow
import type { Dispatch } from '..';

type SetMapStateAction = {
  type: 'SET_MAP_STATE',
  mapState: ?('DAYS' | 'GROUPS')
};

export type Action = SetMapStateAction;

export const setMapState = (mapState: ?('DAYS' | 'GROUPS')) => (
  dispatch: Dispatch
) => dispatch({ type: 'SET_MAP_STATE', mapState });
